import { useMemo } from 'react';
import type { MidnightValue } from '@monorepo/types';

export const useMidnightTableConfig = () => {
  const sortingConfig = useMemo(
    () => ({
      orderBy: 'date',
      order: 'desc' as const,
      onRequestSort: () => {
        // No-op for static data - sorting is handled client-side
      },
    }),
    [],
  );

  const getRowId = useMemo(
    () => (row: Record<string, unknown>) =>
      (row as unknown as MidnightValue)._id,
    [],
  );

  const stableServerDataFetcher = useMemo(
    () => () =>
      Promise.resolve({
        data: [],
        total: 0,
        page: 0,
        pageSize: 0,
        totalPages: 0,
      }),
    [],
  );

  return {
    sortingConfig,
    getRowId,
    stableServerDataFetcher,
  };
};
